module.exports = __webpack_public_path__ + "static/media/sea-lion.1ad0636d.png";